<div class="page-title-area page-title-two">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="page-title-item">
                <h2>Admin</h2>
            </div>
        </div>
    </div>
</div>

<section class="pt-100 pb-70">
    <div class="container">
        <form *ngIf="!unlocked" class="admin-password" (ngSubmit)="submitPassword()">
            <h3>Enter the admin password</h3>
            <div class="form-group">
                <label for="admin-password">Password</label>
                <input
                    id="admin-password"
                    type="password"
                    class="form-control"
                    name="password"
                    autocomplete="current-password"
                    [(ngModel)]="password"
                    required
                />
            </div>
            <p *ngIf="passwordError" class="admin-error">{{ passwordError }}</p>
            <button type="submit" class="btn btn-primary">Continue</button>
        </form>

        <div *ngIf="unlocked">
            <p *ngIf="loading">Loading videos…</p>
            <p *ngIf="loadError" class="admin-error">{{ loadError }}</p>
            <p *ngIf="!loading && !loadError">{{ videoCount() }} videos</p>
            <p *ngIf="downloadError" class="admin-error">{{ downloadError }}</p>

            <div class="admin-group" *ngFor="let group of groups">
                <h3>{{ group.category }}</h3>
                <div class="table-responsive">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>Topic</th>
                                <th>Language</th>
                                <th>Description</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let video of group.videos">
                                <td>{{ video.topic }}</td>
                                <td>{{ video.language }}</td>
                                <td class="description">{{ video.description }}</td>
                                <td>
                                    <button
                                        type="button"
                                        class="btn btn-primary"
                                        (click)="download(video)"
                                        [disabled]="downloadingUrl === video.url"
                                    >
                                        {{ downloadingUrl === video.url ? 'Downloading…' : 'Download' }}
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</section>
